// extracted by mini-css-extract-plugin
export default {"container":"loginOTP_container__bwhH7","hero_container":"loginOTP_hero_container__bNcyQ","login_des":"loginOTP_login_des__A2fFh","confirmButton":"loginOTP_confirmButton__rReRi"};